<div class="landing">
  <div class="header-wrap">
    <header class="header">
      <div class="row">
        <div class="col-12">
          <a routerLink="/" class="header-logo-wrap">
            <img src="/assets/images/login-panel/logo-full.svg" alt="Amadeus Direct">
          </a>
        </div>
      </div>
    </header>
  </div>
  <div class="title-wrap photo-banner photo-banner-full-screen">
    <div class="banner-content">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="content-holder">
            <div class="title">Amadeus Direct</div>
            <div class="message" i18n="@@maintenance-component.maintenance">
              Amadeus Direct portal is currently under maintenance, please try again later. We apologize for any inconvenience caused.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
